import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IBlock } from '../../../models/block.model.i';
import { IExhibitor } from '../../../models/exhibitor.model.i';
import { INavigationInfo } from '../../../models/navigation-info.model.i';
import { ExhibitorService } from '../../exhibitor/services/exhibitor.service';
import { BlockService } from '../services/block.service';
import { NavigationService } from '../services/navigation.service';
import { NavigationUtils } from '../utils/navigation.utils';

enum PositionErrorCode {
    PERMISSION_DENIED = 1,
    POSITION_UNAVAILABLE = 2,
    TIMEOUT = 3,
    UNKNOWN = 4
}

@Component({
    selector: 'app-navigation-page',
    templateUrl: './navigation.page.html',
    styleUrls: ['./navigation.page.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'app-navigation-page mat-elevation-z20'
    }
})

export class NavigationPage implements OnInit {

    exhibitor: IExhibitor;
    block: IBlock;

    navigationInfo: INavigationInfo;
    error: PositionError;

    needsOrientationPermission: Promise<boolean>;

    constructor(activatedRoute: ActivatedRoute,
                exhibitorService: ExhibitorService,
                public navigationService: NavigationService,
                blockService: BlockService,
                private readonly _changeDetector: ChangeDetectorRef) {
        this.exhibitor = exhibitorService.getExhibitor(activatedRoute.snapshot.queryParams.id);
        this.block = blockService.getBlock(this.exhibitor.blockId);

        this.needsOrientationPermission = NavigationUtils.needsDeviceOrientationPermission()
            .then((needsPermission) => {
                if (!needsPermission) {
                    this.startNavigation();
                }

                return needsPermission;
            });
    }

    get errorTitle(): string {
        if (!this.error) {
            return null;
        }

        const code: PositionErrorCode = this.error.code || PositionErrorCode.UNKNOWN;

        switch (code) {
            case PositionErrorCode.PERMISSION_DENIED:
                return 'Fehlende Berechtigung';
            case PositionErrorCode.POSITION_UNAVAILABLE:
                return 'Standortbestimmung nicht verfügbar';
            case PositionErrorCode.TIMEOUT:
                return 'Zeitüberschreitung';
            default:
                return 'Fehler bei der Standortbestimmung';
        }
    }

    ngOnInit() {

    }

    requestOrientationPermission() {
        NavigationUtils.requestDeviceOrientationPermission()
            .then(() => {
                this.needsOrientationPermission = Promise.resolve(false);
                this.startNavigation();
            });
    }

    startNavigation() {
        this.navigationService.getNavigationInfo(this.block)
            .subscribe(
                (next) => {
                    this.navigationInfo = next;
                    this.error = null;
                    this._changeDetector.markForCheck();
                },
                (error) => {
                    this.error = error;
                    this._changeDetector.markForCheck();
                });
    }
}
